export default "__VITE_ASSET__BfN3bJwW__"